import { reactive } from 'vue';

type ProjectNotesDispatchAction =
  | { type: 'start-edit' }
  | { type: 'confirm-edit' }
  | { type: 'cancel-edit' }
  | { type: 'update-notes'; value: string };

interface ProjectNotesStoreState {
  notes: string;
  isEditing: boolean;
  snapshot: string | null;
}

export function createProjectNotesStore(initialNotes: string) {
  const state = reactive<ProjectNotesStoreState>({
    notes: initialNotes,
    isEditing: false,
    snapshot: null,
  });

  function dispatch(action: ProjectNotesDispatchAction): void {
    switch (action.type) {
      case 'start-edit': {
        state.snapshot = state.notes;
        state.isEditing = true;
        break;
      }
      case 'confirm-edit': {
        state.snapshot = null;
        state.isEditing = false;
        break;
      }
      case 'cancel-edit': {
        if (state.snapshot !== null) {
          state.notes = state.snapshot;
        }
        state.snapshot = null;
        state.isEditing = false;
        break;
      }
      case 'update-notes': {
        state.notes = action.value;
        break;
      }
    }
  }

  return { state, dispatch };
}
